import api, { fileUrl } from "@/lib/api";
import PhotoUploader from "@/components/PhotoUploader";
import { Star } from "@phosphor-icons/react";

export default function PhotosTab({ chantierId, photos, onChanged }) {
  return (
    <div className="space-y-3">
      <PhotoUploader chantierId={chantierId} onUploaded={onChanged} />
      <div className="rounded-xl bg-[#005CFF]/5 border border-[#005CFF]/20 p-2.5 text-[10px] text-white/70 flex items-center gap-2">
        <Star size={12} weight="fill" className="text-[#005CFF]" />
        <span>Étoile pleine = photo incluse dans le <b>rapport client</b>. Tapez pour basculer.</span>
      </div>
      <div className="grid grid-cols-3 gap-2" data-testid="photos-grid">
        {photos.length === 0 ? (
          <div className="col-span-3 rounded-xl bg-white/[0.03] border border-dashed border-white/10 p-6 text-center text-white/40 text-sm">Aucune photo</div>
        ) : (
          photos.map((p) => {
            const visible = p.visible_to_client !== false;
            return (
              <div key={p.id} className="aspect-square rounded-xl overflow-hidden bg-white/5 border border-white/10 relative group">
                <a href={fileUrl(p.id)} target="_blank" rel="noreferrer" className="block w-full h-full">
                  <img src={fileUrl(p.id)} alt="" className="w-full h-full object-cover" />
                </a>
                <span className="absolute bottom-1 left-1 text-[9px] uppercase tracking-widest px-1.5 py-0.5 rounded bg-black/60">{p.kind}</span>
                <button
                  onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    try {
                      await api.patch(`/photos/${p.id}`, { visible_to_client: !visible });
                      onChanged();
                    } catch (err) {
                      console.warn(`[photos] toggle visibility failed for ${p.id}:`, err?.message || err);
                    }
                  }}
                  className={`absolute top-1 right-1 w-7 h-7 rounded-full flex items-center justify-center backdrop-blur-md transition-colors ${visible ? "bg-[#005CFF]/80 text-white" : "bg-black/60 text-white/50"}`}
                  title={visible ? "Retirer du rapport client" : "Ajouter au rapport client"}
                  data-testid={`photo-star-${p.id}`}
                >
                  <Star size={13} weight={visible ? "fill" : "regular"} />
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
